import React from 'react';
import { Link } from 'react-router-dom';
const categories = [{
  id: 1,
  title: 'Forex Fundamentals',
  image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  count: 12,
  slug: 'forex-fundamentals'
}, {
  id: 2,
  title: 'Technical Analysis',
  image: 'https://images.unsplash.com/photo-1535320903710-d993d3d77d29?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  count: 15,
  slug: 'technical-analysis'
}, {
  id: 3,
  title: 'Risk Management',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2015&q=80',
  count: 8,
  slug: 'risk-management'
}, {
  id: 4,
  title: 'Trading Psychology',
  image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
  count: 10,
  slug: 'trading-psychology'
}, {
  id: 5,
  title: 'Cryptocurrency Trading',
  image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
  count: 14,
  slug: 'cryptocurrency-trading'
}, {
  id: 6,
  title: 'Advanced Strategies',
  image: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  count: 9,
  slug: 'advanced-strategies'
}];
export function CategoriesSection() {
  return <section className="py-20 bg-zinc-900" data-id="element-26">
      <div className="container mx-auto px-4" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-29">
            Explore Our Trading Classes
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-30">
            From beginner fundamentals to advanced strategies, find the perfect
            class to elevate your trading skills.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-31">
          {categories.map(category => <Link key={category.id} to={`/classes/category/${category.slug}`} className="group cursor-pointer" data-id="element-32">
              <div className="relative overflow-hidden rounded" data-id="element-33">
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-colors z-10" data-id="element-34"></div>
                <img src={category.image} alt={category.title} className="w-full aspect-[16/9] object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-35" />
                <div className="absolute inset-0 z-20 flex flex-col justify-end p-6" data-id="element-36">
                  <h3 className="font-bold text-xl mb-1" data-id="element-37">{category.title}</h3>
                  <p className="text-gray-300 text-sm" data-id="element-38">
                    {category.count} Classes
                  </p>
                </div>
              </div>
            </Link>)}
        </div>
        <div className="text-center mt-12" data-id="element-39">
          <Link to="/classes" className="bg-red-600 text-white px-8 py-3 rounded font-medium text-lg hover:bg-red-700 transition-colors inline-block" data-id="element-40">
            Browse All Classes
          </Link>
        </div>
      </div>
    </section>;
}